import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import {
    ViewDatabaseGuard,
    ViewDealCreation,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { routerPaths } from "@/ui/router/routerPaths";

const PageDealCreation = () => {
    const navigate = useNavigate();
    const { databaseId } = useParams();

    if (databaseId === undefined) {
        return <Navigate to={routerPaths.main.default()} replace={true} />;
    }

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard>
                    <ViewDealCreation
                        databaseId={databaseId}
                        sx={{
                            height: "100%",
                        }}
                    />
                </ViewDatabaseGuard>
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageDealCreation;
